"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_1 = require("react-router");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var Routes_1 = require("../../../../common/enum/Routes");
var navigation_1 = require("../service/navigation");
var NavigationStepLabels_1 = require("../enum/NavigationStepLabels");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var useNavigationSteps = function () {
    var pathname = react_router_1.useLocation().pathname;
    var _a = usePlatformConfig_1.default().platformConfig.platformFeatures, isDealerEnabled = _a.isDealerEnabled, isExtrasPageEnabled = _a.isExtrasPageEnabled;
    var reserveOnlineJourney = [Routes_1.Routes.RESERVE_ONLINE, Routes_1.Routes.PAYMENT, Routes_1.Routes.CONFIRMATION_RESERVE_ONLINE].some(function (p) {
        return pathname.includes(p);
    });
    var extrasPageHasContent = useCheckoutContext_1.default().extrasPageHasContent;
    var steps = reserveOnlineJourney
        ? [
            {
                label: NavigationStepLabels_1.NavigationStepLabels.DETAILS,
                pathname: Routes_1.Routes.RESERVE_ONLINE,
            },
            {
                label: NavigationStepLabels_1.NavigationStepLabels.PAYMENT,
                pathname: Routes_1.Routes.PAYMENT,
            },
            {
                label: NavigationStepLabels_1.NavigationStepLabels.CONFIRMATION,
                pathname: Routes_1.Routes.CONFIRMATION_RESERVE_ONLINE,
            },
        ]
        : [
            {
                label: NavigationStepLabels_1.NavigationStepLabels.DETAILS,
                pathname: Routes_1.Routes.REQUEST_QUOTE,
            },
            {
                label: NavigationStepLabels_1.NavigationStepLabels.CONFIRMATION,
                pathname: Routes_1.Routes.CONFIRMATION_REQUEST_QUOTE,
            },
        ];
    if (isDealerEnabled && !reserveOnlineJourney) {
        steps.unshift({
            label: NavigationStepLabels_1.NavigationStepLabels.DEALER,
            pathname: Routes_1.Routes.DEALER,
        });
    }
    if (isExtrasPageEnabled && extrasPageHasContent) {
        steps.unshift({
            label: NavigationStepLabels_1.NavigationStepLabels.EXTRAS,
            pathname: Routes_1.Routes.EXTRAS,
        });
    }
    var activeStep = navigation_1.default.getActiveStep(pathname, steps, reserveOnlineJourney);
    return { steps: steps, activeStep: activeStep };
};
exports.default = useNavigationSteps;
